<cs-header>
  <cs-header-title>{{ LL.programSettings.advancedTraining.title() }}</cs-header-title>
</cs-header>

<cs-content>
  @if (!loading && declaredState) {
    <div class="advanced-training-methods-container">
      <advanced-methods-component [state]="declaredState" (change)="handleChange()"></advanced-methods-component>
    </div>
  }

  @if (loading) {
    <cs-spinner></cs-spinner>
  }
</cs-content>